export function find_swipers_in_blocks(block_selector, args = {}, sub_args = {}) {
    if (!block_selector) return null;

    const swipers = [];

    document.querySelectorAll(block_selector).forEach((block) => {
        const swiper = block.querySelector('.swiper');
        const pagination = block.querySelector('.slider-navs__pag');
        const prev = block.querySelector('.slider-navs__prev');
        const next = block.querySelector('.slider-navs__next');

        const sub_args_key = Object.keys(sub_args).find((key) => block.classList.contains(key));
        const current_sub_args = sub_args[sub_args_key] || {};
        const current_args = { ...args, ...current_sub_args };

        if (pagination) {
            current_args['pagination'] = {
                el: pagination,
                clickable: true,
                ...current_args['pagination']
            };
        }

        if (prev || next) {
            current_args['navigation'] = {
                prevEl: prev,
                nextEl: next,
                ...current_args['navigation']
            };
        }

        if (block.classList.contains('loading_block')) {
            const old_init = current_args?.on?.init || false;
            const init = function (swiper) {
                block.classList.remove('loading_block');
                if (old_init) old_init(swiper);
            };

            if (!current_args.on) current_args.on = {};

            current_args.on.init = init;
        }
        swipers.push(new Swiper(swiper, current_args));
    });
    return swipers.length ? swipers : null;
}

export function add_swiper_shell(element) {
    const childs = jQuery(element).find('>*');
    childs.addClass('swiper-slide');
    jQuery(element).html('<div class="swiper"><div class="swiper-wrapper"></div></div>');
    jQuery(element).find('.swiper-wrapper').append(childs);
}

export function add_swiper_controls(container) {
    jQuery(container).append(
        '<div class="slider-navs"><div class="slider-navs__prev"></div><div class="slider-navs__pag"></div><div class="slider-navs__next"></div></div>'
    );
}

export function handleClickAccordeon(e) {
    e.preventDefault();
    const title = jQuery(e.target).closest('[data-accordeon-title]');
    jQuery(title).siblings('[data-accordeon-content]').slideToggle();
    jQuery(e.target).closest('[data-accordeon-item]').toggleClass('active');
}

export function handleClickMoreBlockBtn(e) {
    const btn = jQuery(e.target);
    btn.closest('[data-more-block]').find('.more_hide').removeClass('more_hide');
    btn.remove();
}

export function tabsListenerActive({
    selector = '[data-tabs-block=""]',
    callBack = false,
    defaultActiveFind = false,
    effects = true
} = {}) {
    jQuery(selector).each((_key, item) => {
        const currentBlock = jQuery(item);
        const labels = currentBlock
            .find('[data-tab_label_key]')
            .not(currentBlock.find('[data-tabs-block] [data-tab_label_key]'));
        const contents = currentBlock
            .find('[data-tab_content_key]')
            .not(currentBlock.find('[data-tabs-block] [data-tab_content_key]'));

        contents.filter(':not(.active)').hide();

        labels.on('click', (e) => {
            const key = e.target.dataset.tab_label_key ?? false;
            if (!key) return;

            if (effects) {
                jQuery(currentBlock).addClass('loading');
                setTimeout(() => {
                    jQuery(currentBlock).removeClass('loading');
                }, 200);
            }

            labels.removeClass('active');
            contents.removeClass('active').hide();

            jQuery(e.target).addClass('active');
            const currentContent = contents.filter(`[data-tab_content_key=${key}]`);
            currentContent.addClass('active').show();
            if (callBack) callBack([currentBlock, currentBlock, currentContent, e.target, key]);
        });

        if (defaultActiveFind && !currentBlock.filter('[data-tab_label_key].active').get(0)) {
            labels.filter('[data-tab_label_key]:first-child').trigger('click');
        }
    });
}

export function handle_click_radio_nullable(e) {
    const input = e.target.querySelector('[type="radio"]') ?? null;
    if (!input) return;

    if (input.checked) {
        e.preventDefault();
        e.stopPropagation();
        input.checked = false;
        jQuery(input).trigger('change');
    }
}

export function handle_click_input_count(e) {
    const block = jQuery(e.target).closest('[data-count-block]');
    if (!block.get(0)) return;

    const input = block.find('[data-count="value"]');
    const action = e.target?.dataset?.count ?? '';
    let value = Number(input.val());
    value = action === 'plus' ? ++value : --value;
    input.val(value);
    input.trigger('change');
}

export function handle_change_input_count(e) {
    const block = jQuery(e.target).closest('[data-count-block]');
    if (!block.get(0)) return;

    const minus = block.find('[data-count="minus"]');
    const plus = block.find('[data-count="plus"]');
    const input = block.find('[data-count="value"]');

    const value = Number(input.val());
    const min = Number(input.attr('min')) || 0;
    const max = Number(input.attr('max')) || 9999;

    minus.removeClass('disable');
    plus.removeClass('disable');

    if (value <= min) {
        input.val(min);
        minus.addClass('disable');
    }

    if (value >= max) {
        input.val(max);
        plus.addClass('disable');
    }
}

export function check_element_visible(jq_element) {
    const wt = jQuery(window).scrollTop();
    const wh = jQuery(window).height();
    const et = jq_element.offset().top;
    const eh = jq_element.outerHeight();

    const elementTopRelativeToViewport = et - wt;
    const elementBottomRelativeToViewport = elementTopRelativeToViewport + eh;

    if (elementBottomRelativeToViewport > 0 && elementTopRelativeToViewport < wh) {
        // eslint-disable-next-line no-warning-comments
        // Элемент виден в области видимости
        return true;
    } else if (elementBottomRelativeToViewport <= 0) {
        // eslint-disable-next-line no-warning-comments
        // Элемент находится выше видимой области
        return false;
    } else {
        // eslint-disable-next-line no-warning-comments
        // Элемент находится ниже видимой области
        return null;
    }
}

export function is_touch_support() {
    return 'ontouchstart' in document.documentElement || false;
}
